import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ScenariosPicker from './ScenariosPicker';
import Footer from './Footer';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  scenarios: {
    flexGrow: 1,
    maxHeight: '100%',
    overflowY: 'auto',
    width: '100%',
  },
  footer: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
  },
});

const RightSide = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.scenarios}>
        <ScenariosPicker />
      </div>
      <Footer className={classes.footer} />
    </Box>
  );
};

RightSide.defaultProps = {
  className: '',
};

RightSide.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RightSide);
